export enum TitlebarAction {
    drawer = 'drawer',
    back = 'back',
    home = 'home',
    close = 'close',
    custom = 'custom',
    none = '',
}